import React, { useState } from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import { Container, ContentWithPaddingXl } from 'components/misc/Layouts';
import tw from 'twin.macro';
import styled from 'styled-components';
import { css } from 'styled-components/macro';
import { SectionHeading } from 'components/misc/Headings';
import advertisement1 from '../images/advertisement1.jpg';
import advertisement2 from '../images/advertisement2.jpg';
import advertisement3 from '../images/advertisement3.jpg';
import NavBar from 'components/navbars/basic';
import Footer from 'components/footers/MiniCenteredFooter.js';

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900`;
const Posts = tw.div`mt-6 sm:-mr-8 flex flex-wrap`;
const PostContainer = styled.div`
  ${tw`mt-10 w-full sm:w-1/2 lg:w-1/3 sm:pr-8`}
  ${(props) =>
    props.featured &&
    css`
      ${tw`w-full!`}
      ${Post} {
        ${tw`sm:flex-row! h-full sm:pr-4`}
      }
      ${Image} {
        ${tw`sm:h-96 sm:min-h-full sm:w-1/2 lg:w-2/3 sm:rounded-t-none sm:rounded-l-lg`}
      }
      ${Info} {
        ${tw`sm:-mr-4 sm:pl-8 sm:flex-1 sm:rounded-none sm:rounded-r-lg sm:border-t-2 sm:border-l-0`}
      }
      ${Description} {
        ${tw`text-sm mt-3 leading-loose text-gray-600 font-medium`}
      }
    `}
`;
const Post = tw.div`cursor-pointer flex flex-col bg-gray-100 rounded-lg`;
const Image = styled.div`
  ${(props) =>
    css`
      background-image: url('${props.imageSrc}');
    `}
  ${tw`h-64 w-full bg-cover bg-center rounded-t-lg`}
`;
const Info = tw.div`p-8 border-2 border-t-0 rounded-lg rounded-t-none`;
const Category = tw.div`uppercase text-primary-500 text-xs font-bold tracking-widest leading-loose after:content after:block after:border-b-2 after:border-primary-500 after:w-8`;
const CreationDate = tw.div`mt-4 uppercase text-gray-600 italic font-semibold text-xs`;
const Title = tw.div`mt-1 font-black text-2xl text-gray-900 group-hover:text-primary-500 transition duration-300`;
const Description = tw.div``;

export default ({
  headingText = 'Advertisements',
  posts = [
    {
      imageSrc: advertisement1,
      title: 'Join the BHS Family Today!',
      description:
        'Are you looking for a school that offers top-notch education and holistic development? Bright Hope School (BHS) is the place for your child! With a 100% pass rate in NECTA exams and a range of extracurricular activities, we ensure that every student excels both inside and outside the classroom. Visit us to learn more about our day and boarding school options and secure your child’s future with us.',
      featured: true,
    },
    {
      imageSrc: advertisement2,
      title: 'Enroll in Our Extracurricular Clubs – Spaces Filling Fast!',
      description:
        "BHS offers a variety of clubs to nurture your child's interests, from the Mathematics Club to the Arts and Music Club. Our clubs provide a platform for students to explore their passions and develop new skills. Whether your child is interested in sports, science, or entrepreneurship, there's something for everyone at BHS. Sign up today and give your child a chance to shine!",
      featured: true,
    },
    {
      imageSrc: advertisement3,
      title: 'BHS Annual Sports Day – Don’t Miss Out!',
      description:
        'Mark your calendars for Bright Hope School’s Annual Sports Day is around the corner, promising an exciting day of athletic competitions, teamwork, and fun. Come cheer on our students as they showcase their skills in football, netball, and swimming. It’s a perfect opportunity to see our vibrant school community in action!',
      featured: true,
    },
  ],
}) => {
  const [visible, setVisible] = useState(12);
  return (
    <AnimationRevealPage>
      <NavBar />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Posts>
            {posts.slice(0, visible).map((post, index) => (
              <PostContainer key={index} featured={post.featured}>
                <Post className='group'>
                  <Image imageSrc={post.imageSrc} />
                  <Info>
                    <Category>{post.category}</Category>
                    <CreationDate>{post.date}</CreationDate>
                    <Title>{post.title}</Title>
                    {post.featured && post.description && (
                      <Description>{post.description}</Description>
                    )}
                  </Info>
                </Post>
              </PostContainer>
            ))}
          </Posts>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
